module.exports = __webpack_public_path__ + "assets/img/fa70e0d27e839cb54e670f81bce94b8a.svg";